import { isEmpty, isNil, either, when, always } from "ramda"
import { warningMessage } from '@/utils/messages'

export default {
  methods: {
    showNoReportDataWarning( message = null) {
      const displayMessage = when(
        either(isEmpty, isNil),
        always(this.$t('common.warnings.no_report_data'))
      )(message)

      return warningMessage(displayMessage)(this)
    }
  }
}
